import { render, staticRenderFns } from "./classManage.vue?vue&type=template&id=6b19dafa&"
import script from "./classManage.vue?vue&type=script&lang=js&"
export * from "./classManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports